import { jsx as s } from "react/jsx-runtime";

import e from "../../../../utils/classNames/index.js";

/** <tfoot> is not supported as a react-aria-components <Table> child, it will not render
 * https://github.com/adobe/react-spectrum/issues/4372
 * as of 11/5/23: low priority, no timeline
 */ const a = ({className: a, children: l, ...t}) => s("div", {
    ...t,
    className: e("gap-s pt-m px-xs pb-s flex min-w-full overflow-auto bg-white", a),
    children: l
});

export { a as default };
//# sourceMappingURL=index.js.map
